// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import SectionColumn from "../SectionColumn"
import { serializers } from "../Serializers"

// ** 3rd Party Library
import { PortableText } from "@portabletext/react"

const SectionProfileCard = ({ section }: any) => {
  const {
    media: { image_desktop },
    _rawContent: content,
  } = section
  return (
    <Container fullWidthOnMobile={false} constrainedToBreakPoint>
      <SectionColumn className="bg-[#F9F9FA] p-10 rounded-[20px] items-center border border-[#E0E0E0] shadow-lg">
        <Box className="lg:basis-3/12 px-10 max-w-[300px] ">
          <GatsbyImage
            image={image_desktop?.asset?.gatsbyImageData}
            alt={image_desktop?.asset?.altText || "section profile card"}
            imgClassName="shadow-lg"
          />
        </Box>
        <Box className="lg:flex-1">
          <Box className="py-8">
            <PortableText components={serializers} value={content} />
          </Box>
        </Box>
      </SectionColumn>
    </Container>
  )
}

export default SectionProfileCard
